import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE, timeout: 12000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kw_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Retry idempotent GETs on timeout / network / 5xx (handles intermittent edge stalls).
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const config = error.config || {};
    const method = (config.method || "get").toLowerCase();
    const retriable =
      !error.response ||
      error.code === "ECONNABORTED" ||
      error.code === "ERR_NETWORK" ||
      (error.response && error.response.status >= 500);
    if (method === "get" && retriable && (config.__retry || 0) < 3) {
      config.__retry = (config.__retry || 0) + 1;
      await new Promise((res) => setTimeout(res, 300 * config.__retry));
      return api(config);
    }
    return Promise.reject(error);
  }
);

// Tenancy travels as a query param (simple request, no CORS preflight).
export function setPortalHeader(key) {
  api.defaults.params = { ...(api.defaults.params || {}) };
  if (key) api.defaults.params.portal_key = key;
  else delete api.defaults.params.portal_key;
}

export function formatApiError(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
